const {
	PATH,
	makeMemberApplicationPath,
	makeMemberPortalPath,
	makeMembershipsPath,
	makeProgramsApplicationPath,
} = require('./appPaths')

// Helmet and first-HTML copy. byPath keys use PATH helpers so a route
// rename updates lookup.

// Same floor as src/html/index.html and SiteMetadata. Empty WP / Helmet
// descriptions fall back here so first HTML and hydration stay one tag.
const DEFAULT_SEO_DESCRIPTION =
	'Boat towing and on-water service with 24/7 assistance from expert Captains. Sea Tow offers free towing for members. Salvage and boat recovery. Call 800-4-SEATOW.'

function normalizeSeoDescription(value) {
	return String(value || '').trim() || DEFAULT_SEO_DESCRIPTION
}

const MEMBERS = {
	metaTitle: 'Login | Manage and Renew Your Membership | Sea Tow',
	description:
		'Access your Sea Tow Member Dashboard. Manage your membership, renew plans, and explore exclusive boating benefits and services.',
}

const MEMBERS_RENEW = {
	metaTitle: 'Renew Your Membership | On-Water Assistance | Sea Tow',
	description:
		'Renew your Sea Tow Membership easily online and continue enjoying 24/7 on-water assistance, towing, and exclusive boater benefits.',
}

const MEMBERS_GIFT = {
	metaTitle: 'The Gift of a Sea Tow Membership | Gifts for Boaters | Sea Tow',
	description:
		'Give the gift of Peace of Mind on the Water™. Purchase a Sea Tow gift membership today and provide 24/7 on-water assistance to the boater in your life.',
}

const PROGRAMS_APPLY = {
	metaTitle: 'Apply for Sea Tow Affiliate Programs | Sea Tow',
	description:
		'Apply to participate in Sea Tow programs today. Submit your application to promote your business to members, include membership with a sale, or sell membership at your store.',
}

const TRAILER_CARE = {
	metaTitle: 'Trailer & Towing Care | 24/7 Roadside Assistance | Sea Tow',
	description:
		'Add Trailer Care to your Sea Tow Membership for roadside trailer assistance and complete peace of mind on and off the water.',
}

const PROGRAMS = {
	metaTitle: 'Affiliate Program Opportunities | Sea Tow',
	description:
		'Learn about Sea Tow programs offering professional boating assistance, partnerships, and benefits for members and marine businesses.',
}

const MEMBERS_JOIN = {
	metaTitle: 'Become a Sea Tow Member | Sea Tow',
	description:
		'Join Sea Tow today for boat towing services nationwide. Professional Captains are standing by 24/7 to assist with all your on-water assistance needs.',
}

const MEMBERS_JOIN_QUESTIONNAIRE = {
	metaTitle: 'Membership Advisor | Become a Sea Tow Member | Sea Tow',
	description:
		'Complete the Sea Tow member questionnaire to help us understand how you use your boat and help choose the membership that best fits your boating needs.',
}

const BASE = {
	metaTitle: 'Boat Towing & 24/7 On-Water Assistance | Sea Tow',
	description:
		'Providing leading on-water assistance to boaters since 1983. A Sea Tow Membership includes a full-suite of on-water assistance services for every boat you own, rent, or borrow.',
}

const SITE_METADATA = {
	MEMBERS,
	MEMBERS_RENEW,
	MEMBERS_GIFT,
	PROGRAMS_APPLY,
	TRAILER_CARE,
	PROGRAMS,
	MEMBERS_JOIN,
	MEMBERS_JOIN_QUESTIONNAIRE,
	BASE,
}

// Videos come from WordPress (wpVideoSeo.js), not this map.
// Longer prefixes win (e.g. questionnaire over /members/join).
const byPath = {
	[PATH.ROOT]: BASE,
	[PATH.MEMBER_PORTAL]: MEMBERS,
	[makeMemberPortalPath(PATH.SEA_TOW_AS_A_GIFT)]: MEMBERS_GIFT,
	[makeMemberApplicationPath()]: MEMBERS_JOIN,
	[makeMemberApplicationPath(PATH.NEW_MEMBER_QUESTIONNAIRE)]:
		MEMBERS_JOIN_QUESTIONNAIRE,
	[makeMemberPortalPath(PATH.RENEW_MEMBERSHIP)]: MEMBERS_RENEW,
	[PATH.PROGRAMS_PORTAL]: PROGRAMS,
	[makeProgramsApplicationPath()]: PROGRAMS_APPLY,
}

// Exact match only — do not treat as a prefix (or /members would steal gift/join).
const exactOnly = {
	[PATH.ROOT]: true,
	[PATH.MEMBER_PORTAL]: true,
}

// Renewal / trailer-care flows also live under /members/memberships/:sfid/...
function escapeRegExp(value) {
	return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const membershipRecord = `${escapeRegExp(makeMembershipsPath())}/[^/]+`
const pathPatterns = [
	[
		new RegExp(
			`^${membershipRecord}${escapeRegExp(PATH.RENEW_MEMBERSHIP)}(?:/|$)`,
		),
		MEMBERS_RENEW,
	],
	[
		new RegExp(
			`^${membershipRecord}${escapeRegExp(PATH.UPGRADES)}${escapeRegExp(
				PATH.TRAILER_CARE,
			)}(?:/|$)`,
		),
		TRAILER_CARE,
	],
]

module.exports = {
	DEFAULT_SEO_DESCRIPTION,
	SITE_METADATA,
	byPath,
	exactOnly,
	pathPatterns,
	normalizeSeoDescription,
}
